import { getLocaleId } from 'utils/getLocaleId'
import { useGetMeLazyQuery } from 'api/hooks'
import { initLocalStorage } from 'components/Common/Menu/_methods'
import { DEFAULT_PATH } from 'utils/consts/path'
import { useDispatch } from 'react-redux'
import { setData, setSelectedCompanyId } from 'store/me'
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom'

export const useGetMeData = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const [getMe] = useGetMeLazyQuery({
    variables: { localeId: getLocaleId() },
    context: { ignoreAccessErrors: true },
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      if (!data?.me) return
      const pathname =
        location?.state?.from?.pathname || searchParams.get('from')
      const redirectPath =
        pathname === '/' ? DEFAULT_PATH : pathname || DEFAULT_PATH
      const { selectedCompany } = initLocalStorage(data?.me)

      dispatch(setData(data.me))
      dispatch(setSelectedCompanyId(selectedCompany?.id))

      navigate(redirectPath, { replace: true })
    },
  })
  return getMe
}
